import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonBase } from '@mui/material';
import config from 'config';
import { MENU_OPEN } from 'store/actions';
import { fetchUserProfile, getLogoFromToken } from 'core/apis/common';
import { BASE_URL, urls } from 'core/constant/urls';
import defaultLogo from '../../../assets/logo.png'
import { useEffect } from 'react';
import { useState } from 'react';
import { getApi } from 'core/apis/apiClient';
// const logo = getLogoFromToken()

const LogoSection = () => {
  const navigate = useNavigate()
  const [logo, setLogo] = useState()
  const imgUrl = `${BASE_URL}/${logo}`
  const handleNavigate = () => {
    navigate('/dashboard/default')
  }

  const ApiCall = async () => {
    // const response = await fetchUserProfile();
    // setLogo(response?.data?.companyLogo);
    const url = urls?.endpoints?.user?.fetchLogo
    const response = await getApi(url)
    setLogo(response?.data?.companyId?.companyLogo);
  }

  useEffect(() => {
    ApiCall();
  }, [])

  return (
    <ButtonBase disableRipple onClick={handleNavigate}>
      <img src={logo ? imgUrl : defaultLogo} alt='Logo' style={{ height: '70px', width: '180px', objectFit: 'contain' }} />
    </ButtonBase>
  );
};

export default LogoSection;
